export default __webpack_public_path__ + "static/twitter-112d93100806a70e5d28e3c0d8292a9f.png";